module.exports = __webpack_public_path__ + "static/media/arrow-dogweb-down.65693db0.svg";